import React from 'react';
import PropTypes from 'prop-types';

class LimitedTextArea extends React.Component {
  constructor (props, context) {
    super(props, context);

    this.state = {
      characterCount: (props.defaultValue || '').length
    };

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange (event) {
    this.setState({
      characterCount: event.target.value.length
    });

    if (this.props.onChange !== undefined) {
      this.props.onChange(event);
    }
  };

  render () {
    return (
      <div className='LimitedTextArea'>
        <textarea name={this.props.name} id={this.props.id} className={this.props.className} maxLength={this.props.characterLimit}
          placeholder={this.props.placeholder} rows={this.props.rows} onChange={this.handleOnChange}
          defaultValue={(this.props.defaultValue || '').substr(0, this.props.characterLimit)} />
        <span className='LimitedTextArea__CharacerDisplay'>{this.state.characterCount}/{this.props.characterLimit}</span>
      </div>
    );
  }
};

LimitedTextArea.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  characterLimit: PropTypes.number.isRequired,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  defaultValue: PropTypes.string
};

LimitedTextArea.defaultProps = {
  defaultValue: ''
};

export default LimitedTextArea;



// WEBPACK FOOTER //
// ./src/components/Form/LimitedTextArea.js